import {
	QueryClient,
	QueryClientProvider,
} from "@tanstack/react-query";
import { useEffect } from "react";
import { BrowserRouter } from "react-router";
import { MyRouter } from "./pages/Router";
import { ToastContainer } from "react-toastify";
import { HttpError } from "./ts/api/comunicacion";
import { AuthProvider } from "./hooks/useAuth";

function App() {
	const queryClient = new QueryClient({
		defaultOptions: {
			queries: {
				refetchOnWindowFocus: false,
				retry: (attempts, err) => {
					if (err instanceof HttpError === false) return true;

					if (err.status === 404) return false;
					if (err.status === 401) return false;

					return true;
				}
			}
		}
	});
	useEffect(() => {
		const html = document.querySelector("html");
		const onDown = (event: KeyboardEvent) => {
			if (event.key === "Control") {
				html?.classList.add("ctrPressed");
			}
		};
		const onUp = (event: KeyboardEvent) => {
			if (event.key === "Control") {
				html?.classList.remove("ctrPressed");
			}
		};

		document.addEventListener("keydown", onDown);
		document.addEventListener("keyup", onUp);
		return () => {
			document.removeEventListener("keydown", onDown);
			document.removeEventListener("keyup", onUp);
		};
	}, []);
	return (
		<AuthProvider>
			<QueryClientProvider client={queryClient}>
				<BrowserRouter>
					<MyRouter />
				</BrowserRouter>
				<ToastContainer />
			</QueryClientProvider>
		</AuthProvider>
	);
}

export default App;
